// extracted by mini-css-extract-plugin
export default {"not_found_msg":"NotFound_not_found_msg__tb9Vt"};